'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _popupMenuLocal = require('./popup-menu.local.css');

var _popupMenuLocal2 = _interopRequireDefault(_popupMenuLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PopupMenuItem = function PopupMenuItem(_ref) {
  var children = _ref.children,
      href = _ref.href,
      rel = _ref.rel,
      alt = _ref.alt,
      target = _ref.target,
      id = _ref.id,
      onClick = _ref.onClick,
      className = _ref.className,
      iconClassName = _ref.iconClassName,
      AnchorComponent = _ref.AnchorComponent,
      icon = _ref.icon;
  var elementProps = {
    className: _popupMenuLocal2.default.popupItemButton,
    href: href,
    rel: rel,
    alt: alt,
    target: target,
    onClick: onClick ? function (ev) {
      ev.preventDefault();
      onClick();
    } : null
  };

  var innerElement = _react2.default.createElement('span', {
    className: (0, _classnames2.default)(_popupMenuLocal2.default.anchorContent, className)
  }, icon ? _react2.default.createElement(_icon2.default, {
    icon: icon,
    iconColor: 'currentColor',
    className: (0, _classnames2.default)(_popupMenuLocal2.default.anchorIcon, iconClassName),
    size: 'medium'
  }) : null, children);

  return _react2.default.createElement('li', {
    className: _popupMenuLocal2.default.popupItem,
    id: id
  }, (0, _react.cloneElement)(AnchorComponent || (0, _react.createElement)('a'), elementProps, innerElement));
};

PopupMenuItem.defaultProps = {
  href: null,
  rel: null,
  alt: null,
  target: null,
  icon: null,
  AnchorComponent: null
};
PopupMenuItem.propTypes = {
  /**
   * URL this navigates to
   */
  href: _propTypes2.default.string,

  /**
   * Anchor tag rel property
   */
  rel: _propTypes2.default.string,

  /**
   * Alternative text for accessiblity
   */
  alt: _propTypes2.default.string,

  /**
   * Anchor tag target property
   */
  target: _propTypes2.default.string,

  /**
   * HTML id
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Rendered content
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * Custom className
   */
  className: _propTypes2.default.string,

  /**
   * Method called when user clicks
   */
  onClick: _propTypes2.default.func,

  /**
   * AnchorComponent override
   */
  AnchorComponent: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),

  /**
   * string name of icon
   */
  icon: _propTypes2.default.string,

  /**
   * className that will be passed to the Icon component
   */
  iconClassName: _propTypes2.default.string
};
exports.default = PopupMenuItem;